import { render, staticRenderFns } from "./DataloadServices.vue?vue&type=template&id=2e004ffd&"
import script from "./DataloadServices.vue?vue&type=script&lang=js&"
export * from "./DataloadServices.vue?vue&type=script&lang=js&"
import style0 from "./DataloadServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports